/**
 * PostHog A/B Test Utilities
 * JS escape hatch for cases where CSS show/hide isn't enough
 * (buy box variants, Recharge widget swaps, ajax content, etc.)
 *
 * Flags are populated by the initAbTest() function in theme.liquid
 * which stores resolved flags on window.__posthogFlags.
 *
 * Usage:
 *   // Callback when flag resolves
 *   PHTest.onFlag('buy_box_variant', (variant) => {
 *     if (variant === 'recharge') {
 *       document.querySelector('.frontrow-widget')?.remove();
 *     }
 *   });
 *
 *   // Async/await
 *   const variant = await PHTest.getFlag('buy_box_variant');
 *   if (variant === 'test') { ... }
 */
class PHTest {
  static _pendingCallbacks = [];

  static onFlag(flagKey, callback) {
    if (window.__posthogFlags) {
      const flag = window.__posthogFlags[flagKey];
      if (flag && flag.enabled) {
        callback(flag.variant || true);
      }
    } else {
      this._pendingCallbacks.push({ flagKey, callback });
    }
  }

  static getFlag(flagKey) {
    return new Promise(function (resolve) {
      if (window.__posthogFlags) {
        var flag = window.__posthogFlags[flagKey];
        resolve(flag && flag.enabled ? (flag.variant || true) : false);
      } else {
        var check = setInterval(function () {
          if (window.__posthogFlags) {
            clearInterval(check);
            var flag = window.__posthogFlags[flagKey];
            resolve(flag && flag.enabled ? (flag.variant || true) : false);
          }
        }, 50);
        setTimeout(function () { clearInterval(check); resolve(false); }, 5000);
      }
    });
  }

  static _flushPending() {
    if (!window.__posthogFlags) return;
    this._pendingCallbacks.forEach(function (entry) {
      var flag = window.__posthogFlags[entry.flagKey];
      if (flag && flag.enabled) {
        entry.callback(flag.variant || true);
      }
    });
    this._pendingCallbacks = [];
  }
}

window.PHTest = PHTest;
